import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import {  MoveLeft, MoveRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getBlogs } from '../../api/Blogs/GetAllBlogs';
import Spinner from '../Shared/Spinner';

const Blogs = () => {
    const { data: BlogsResponse, isLoading: isBlogsLoading } = useQuery({
        queryFn: getBlogs,
        queryKey: ["blogs"],
        staleTime: 0,
        refetchInterval: 0,
    });

    const blogs = Array.isArray(BlogsResponse?.data?.blogsData) ? BlogsResponse?.data?.blogsData : [];

    return (
        <div className='sm:pb-24 pb-16'>
            <div className="relative z-50 md:space-y-5 space-y-2.5 text-center sm:pt-20 pt-14">
                <h1 className="font-semibold sm:text-base text-sm text-secondary">Article</h1>
                <h2 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-textPrimary mx-auto">Exploring The Latest Blogs</h2>
                <p className="max-w-[764px] mx-auto sm:text-base text-sm">
                    Stay informed and inspired with our insightful articles! Dive into a wealth of knowledge as we cover the latest trends, tips, and strategies in education and professional development to help you excel in your journey.
                </p>
            </div>

            <div className="relative z-50 container px-2.5 mt-16">
                {isBlogsLoading ? (
                    <div className="min-h-[50vh] flex items-center justify-center">
                        <Spinner />
                    </div>
                ) : (

                    <Swiper
                        grabCursor={true}
                        navigation={{
                            nextEl: ".custom-next3",
                            prevEl: ".custom-prev3",
                        }}
                        loop={true}
                        slidesPerView={3}
                        spaceBetween={30}
                        autoplay={{
                            delay: 500,
                            disableOnInteraction: false,
                        }}
                        modules={[Autoplay, Navigation]}
                        speed={3000}
                        className="mySwiper"
                        breakpoints={{
                            0: {
                                slidesPerView: 1.2,
                                spaceBetween: 10,
                            },
                            550: {
                                slidesPerView: 1.6,
                                spaceBetween: 10,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 12,
                            },
                            768: {
                                slidesPerView: 2.5,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 25,
                            },
                        }}
                    >
                        {blogs?.map(slide => (
                            <SwiperSlide key={slide.id} className="relative">
                                <div className="relative group">
                                    <Link to={`/blog/${slide.id}`}>
                                        <img src={slide.img_url} className="sm:h-[265px] h-[230px] w-full relative object-fit border transition-all duration-300 group-hover:border-secondary" alt="" />
                                    </Link>
                                    <div className="bg-white flex flex-col justify-end">
                                        <Link className='text-xl text-textPrimary md:py-5 py-2.5 font-medium group-hover:text-secondary transition-all duration-300' to={`/blog/${slide.id}`}>{slide.title}</Link>
                                        <span className='text-[#858585] text-sm'>{slide.description.split(' ').slice(0, 25).join(' ')} <span className="text-primary">...</span></span>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
                <div className="flex justify-center mx-auto sm:gap-5 gap-2.5 items-center mt-7 w-full ">
                    <button className="custom-prev3 hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                        <MoveLeft className="text-secondary group-hover:text-white sm:w-8 w-6" size={32} />
                    </button>
                    <div>
                        <div className="custom-pagination2"></div>
                    </div>
                    <button className="custom-next3 hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                        <MoveLeft className="rotate-180 text-secondary group-hover:text-white sm:w-8 w-6" size={32} />
                    </button>
                </div>
            </div>
            <Link className='text-center border rounded-full sm:px-6 px-4 sm:py-2.5 py-2 sm:mt-5 mt-9 w-fit mx-auto hover:border-secondary border-textPrimary text-textPrimary text-sm text-inherit font-semibold sm:text-xl hover:text-secondary  transition-all items-center duration-300 flex justify-center gap-2' to={'/blogs'}>
            See More <MoveRight className='sm:size-6 size-5'/>
            </Link>
        </div>
    )
}

export default Blogs